import { MessagePageWrapper } from "./styles";
import { MAIN_URL } from "util/consts";
import { ReactComponent as Logo } from "assets/icons/logo.svg";

export const MessagePage = ({ color, children }) => {
  return (
    <MessagePageWrapper color={color}>
      <a className="ls-logo-website" href={MAIN_URL}>
        <Logo height={32} width={176} />
      </a>
      <div className="ls-content">{children}</div>
    </MessagePageWrapper>
  );
};
